/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", () => {
    const block = document.querySelector(".wp-block-bdmc-genially");
    console.log(block);
	if (!block) return;

	const iframe = block.querySelector(".genially-iframe");
	const links = JSON.parse(block.dataset.links || "[]");
	if (!links.length) return;

	const STORAGE_KEY = "genially_quiz_done";

	// Récupère les quiz déjà vus depuis le localStorage
	let done = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");

	// Filtre pour garder seulement ceux non encore faits
	let remaining = links.filter(link => !done.includes(link));

	// Si tous les quiz ont été faits
	if (remaining.length === 0) {
		iframe.remove();
		block.innerHTML = `
            <div class="d-flex justify-content-center mt-3">
				<div class="genially-end-message">
					<p>🎉 Tu as déjà fait tous les quiz disponibles ! 😉</p>
					<button id="genially-reset" class="g-btn type_default">Recommencer</button>
				</div>
            </div>
		`;
		document.querySelector("#genially-reset").addEventListener("click", () => {
			localStorage.removeItem(STORAGE_KEY);
			location.reload();
		});
		return;
	}

	// Choisir un quiz aléatoire parmi les restants
	const randomIndex = Math.floor(Math.random() * remaining.length);
	const selectedQuiz = remaining[randomIndex];

	// Met à jour l'iframe
	iframe.src = selectedQuiz;

	// Écouteur pour enregistrer le quiz comme "fait"
	iframe.addEventListener("load", () => {
		// Exemple : ici on considère que le quiz est "terminé" dès qu’il est affiché
		// Tu peux affiner la logique selon ton besoin (ex: message "quiz terminé")
		if (!done.includes(selectedQuiz)) {
			done.push(selectedQuiz);
			localStorage.setItem(STORAGE_KEY, JSON.stringify(done));
		}
	});
});